import { Button } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';

import { RespondentType } from './generated/referral-request';
import { useReferralRequestForm } from './hooks/use-referral-request-form';
import { useReferralRequestFormHandlers } from './hooks/use-referral-request-form-handlers';
import { ReferralRequestForm } from './referral-request-form';
import { type ReferralRequestFormValues } from './referral-request-form-utils';
import { type FormValues } from './respondent-fields';

type ReferralRequestService = { description: string; respondentTypes: RespondentType[] };

type ReferralRequestFormPageProps = {
  readonly initialValues?: FormValues;
  readonly onSave: (values: ReferralRequestFormValues) => Promise<void> | void;
  readonly service: ReferralRequestService;
};

const ReferralRequestFormPage = ({ initialValues, onSave, service }: ReferralRequestFormPageProps) => {
  const { t } = useTranslation();
  const form = useReferralRequestForm(initialValues, service.respondentTypes);
  const { isSavingDraft, saveDraftHandler } = useReferralRequestFormHandlers({
    form,
    onSaveDraft: onSave,
    respondentTypes: service.respondentTypes,
  });

  return (
    <ReferralRequestForm
      form={form}
      renderActions={() => (
        <Button disabled={isSavingDraft} loading={isSavingDraft} onClick={saveDraftHandler} type="button">
          {t('page.professionalReferral.referralRequest.saveAndContinueButton')}
        </Button>
      )}
      service={service}
    />
  );
};

export { ReferralRequestFormPage };
export type { ReferralRequestService };
